import { ComponentPropsWithRef } from "react";
import { semanticRed01, shade0 } from "../../../../styles/tokens";

export const ErrorIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={semanticRed01} />
    <path
      d="M28.9648 16.259L31.719 19.0131C31.9733 19.2674 31.9724 19.6778 31.719 19.9312L27.6501 24L31.719 28.0688C31.9733 28.3231 31.9724 28.7335 31.719 28.9869L28.9648 31.741C28.7114 31.9944 28.301 31.9953 28.0467 31.741L23.9779 27.6722L19.9091 31.741C19.6557 31.9944 19.2453 31.9953 18.991 31.741L16.2369 28.9869C15.9835 28.7335 15.9835 28.3222 16.2369 28.0688L20.3057 24L16.2369 19.9312C15.9835 19.6778 15.9835 19.2665 16.2369 19.0131L18.991 16.259C19.2444 16.0056 19.6557 16.0056 19.9091 16.259L23.9779 20.3278L28.0467 16.259C28.3001 16.0056 28.7114 16.0056 28.9648 16.259Z"
      fill={shade0}
    />
  </svg>
);
